import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-edit-text-box',
    templateUrl: './edit-text-box.html',
    styleUrls: ['./edit-text-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditTextBoxDialog implements OnInit {

    title: string;
    newText: string;

    constructor(
        public dialogRef: MatDialogRef<EditTextBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.newText = data.text;
        this.title = data.title;
    }

    ngOnInit() {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.newText);
    }
}
